
































































































import Vue from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { EUserPermissions, IFacility, US_STATES_LIST } from '@zunta/configurations'
import { minLength, required } from 'vuelidate/lib/validators'
import { ZIP_MASK } from '@/constants'
import { getModule } from 'vuex-module-decorators'
import { FacilityModule } from '@/store/modules/facility.module'
import { User } from '@/classes/User'
import Api from '@/api'

@Component({
  components: { InputValidator, InputV2, Checkbox, SelectV2, ModalV2 }
})
export default class ReturnEnvelopeModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  ZIP_MASK: string = ZIP_MASK

  facilityData: Partial<IFacility> = {
    includeReturnEnvelope: false,
    returnAddress: '',
    returnBillingAddress: '',
    returnCity: '',
    returnState: '',
    returnZip: '',
    attentionTo: ''
  }

  isLoading: boolean = false

  validations (): any {
    return {
      facilityData: {
        returnAddress: {
          required
        },
        returnBillingAddress: {
          required
        },
        returnCity: {
          required
        },
        returnState: {
          required
        },
        returnZip: {
          required,
          minLength: minLength(5)
        }
      }
    }
  }

  get statesList () {
    return Object.keys(US_STATES_LIST).map((stateShortName: string) => ({
      value: stateShortName,
      key: stateShortName,
      content: US_STATES_LIST[stateShortName]
    }))
  }

  get selectedFacility (): IFacility {
    return this.$store.state.facility.selectedFacility
  }

  mounted () {
    this.facilityData = { ...this.selectedFacility }
  }

  setDefaultFacilityAddress () {
    if (!this.facilityData.includeReturnEnvelope) {
      return
    }
    this.facilityData.returnAddress = this.facilityData.returnAddress ? this.facilityData.returnAddress : this.selectedFacility.name
    this.facilityData.returnBillingAddress = this.facilityData.returnBillingAddress ? this.facilityData.returnBillingAddress : this.selectedFacility.street
    this.facilityData.returnCity = this.facilityData.returnCity ? this.facilityData.returnCity : this.selectedFacility.city
    this.facilityData.returnState = this.facilityData.returnState ? this.facilityData.returnState : this.selectedFacility.state
    this.facilityData.returnZip = this.facilityData.returnZip ? this.facilityData.returnZip : this.selectedFacility.zip
  }

  async save () {
    if (!this.selectedFacility) {
      return
    }

    this.$v.$touch()

    if (this.$v.$anyError) {
      return
    }

    if (!this.user.hasPermissionFor(EUserPermissions.EDIT_STATEMENT_SETTINGS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Edit Statement Settings`,
        icon: 'warning'
      })
      return
    }

    try {
      this.isLoading = true

      await this.facilityModuleInstance.updateFacility({
        id: this.selectedFacility.id as number,
        data: this.facilityData
      })
    } finally {
      this.isLoading = false
      this.$emit('close')
    }
  }
}
